module.exports = __webpack_public_path__ + "img/2.725d2ba3.png";